module.exports = __webpack_public_path__ + "img/lv12.9002a100.png";